import angular from 'angular'
import './posts.service'
import './comments/comments.controller'
import './comments/comments.service'
import './edit/edit.controller'

angular
  .module('pub.post', ['pub.posts.service', 'pub.post.comments', 'pub.post.edit'])
  .controller('PostsCtrl', PostsCtrl)

/** @ngInject */
function PostsCtrl(
  $scope,
  $state,
  $q,
  $sce,
  $rootScope,
  $stateParams,
  PostsService,
  UserCache,
  CacheService,
  UploadService,
) {
  var vm = this
  vm.itemsDraft = []
  vm.itemsPublished = []
  vm.items = []
  vm.pathImgT = ''
  vm.pathImgH = ''
  vm.create = false
  vm.model = {}
  vm.usersPerPage = 25

  vm.sortType = 'n-asc'
  vm.sortReverse = false
  vm.sortType2 = 'ts-p-desc'
  vm.sortReverse2 = false

  function loadPaginationDraft() {
    vm.totalUsers = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function loadPaginationPublish() {
    vm.totalUsers2 = 0
    vm.oldPage2 = 0
    vm.currentPage2 = 25
    vm.first2 = true
    vm.totalItems2 = 0
    vm.pagination2 = {
      current: 1,
    }
  }

  //draft
  loadPaginationDraft()

  //published
  loadPaginationPublish()

  loadDraft(1)
  loadPublished(1)

  var tab = localStorage.getItem('tabpublisher')
  if (tab !== null) {
    if (tab === 'draft') {
      $('#published').removeClass('active')
      $('#draft').addClass('active')
      $('#drafttab').addClass('active')
    } else {
      $('#draft').removeClass('active')
      $('#published').addClass('active')
      $('#publishedtab').addClass('active')
    }
  } else {
    $('#draft').addClass('active')
    $('#drafttab').addClass('active')
  }

  var oldSortType, oldSortType2
  function loadDraft(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    oldSortType = angular.copy(vm.sortType)
    PostsService.listDraft($stateParams.parentId, vm.oldPage, 25, vm.sortType).then(
      function (result) {
        var posts = result.results
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct
        }
        for (var i = 0; i < posts.length; i++) {
          posts[i].editing = false
          posts[i].loadT = false
          posts[i].loadH = false
          posts[i].status = 'Draft'
          if (posts[i]['ts-p'] !== undefined) {
            posts[i].isPub = true
            posts[i]['ts-p'] = new Date(
              parseInt(
                posts[i]['ts-p'].toString().substring(0, posts[i]['ts-p'].toString().length - 3),
              ),
            )
            if (posts[i]['ts-p'] > new Date()) {
              posts[i].status = 'Pending'
            }
          } else {
            posts[i].isPub = false
          }
          posts[i].ts = new Date(
            parseInt(posts[i].ts.toString().substring(0, posts[i].ts.toString().length - 3)),
          )

          if (posts[i]['img-h'].indexOf('mp4') !== -1 || posts[i]['img-h'].indexOf('mov') !== -1) {
            posts[i].isVideo = true
            posts[i].video = $sce.trustAsResourceUrl(
              $rootScope.urlS3 + '/posts/' + posts[i]['img-h'],
            )
          } else {
            posts[i].isVideo = false
          }
        }

        vm.sortType = oldSortType
        vm.itemsDraft = posts
        vm.disableTable = false
      },
    )
  }

  vm.pageChangedDraft = function (newPage) {
    $('html, body').animate({ scrollTop: 0 }, 0)
    vm.sortType = oldSortType
    loadDraft(newPage)
  }

  function loadPublished(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination2.current = 1
    }
    if (!vm.first2) {
      vm.currentPage2 = pageNumber * 25
      vm.oldPage2 = vm.currentPage2 - 25
    } else {
      vm.first2 = false
    }

    oldSortType2 = angular.copy(vm.sortType2)
    PostsService.listPublished($stateParams.parentId, vm.oldPage2, 25, vm.sortType2).then(
      function (result) {
        var posts = result.results
        if (vm.totalItems2 === 0) {
          vm.totalItems2 = result.ct
        }
        for (var i = 0; i < posts.length; i++) {
          posts[i].editing = false
          posts[i].loadT = false
          posts[i].loadH = false
          if (posts[i]['ts-p'] !== undefined) {
            posts[i].isPub = true
            posts[i]['ts-p'] = new Date(
              parseInt(
                posts[i]['ts-p'].toString().substring(0, posts[i]['ts-p'].toString().length - 3),
              ),
            )
          } else {
            posts[i].isPub = false
          }
          posts[i].ts = new Date(
            parseInt(posts[i].ts.toString().substring(0, posts[i].ts.toString().length - 3)),
          )

          if (posts[i]['img-h'].indexOf('mp4') !== -1 || posts[i]['img-h'].indexOf('mov') !== -1) {
            posts[i].isVideo = true
            posts[i].video = $sce.trustAsResourceUrl(
              $rootScope.urlS3 + '/posts/' + posts[i]['img-h'],
            )
          } else {
            posts[i].isVideo = false
          }
        }

        vm.sortType2 = oldSortType2
        vm.itemsPublished = posts
      },
    )
  }

  vm.pageChangedPublished = function (newPage) {
    $('html, body').animate({ scrollTop: 0 }, 0)
    vm.sortType2 = oldSortType2
    loadPublished(newPage)
  }

  vm.tabDraft = function () {
    $('#published').removeClass('active')
    $('#draft').addClass('active')
    localStorage.setItem('tabpublisher', 'draft')
  }

  vm.tabPublished = function () {
    $('#draft').removeClass('active')
    $('#published').addClass('active')
    localStorage.setItem('tabpublisher', 'published')
  }

  vm.add = function () {
    $state.go('pub.channels.posts.edit', { id: 0 })
  }

  vm.edit = function (item) {
    vm.model = item
  }

  vm.delete = function (item) {
    swal(
      {
        title: 'Are you Sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          if (item['ts-p'] !== undefined || item['ts-p'] !== null) {
            PostsService.update($stateParams.parentId, item.id, { 'ts-p': null }).then(function () {
              PostsService.remove($stateParams.parentId, item.id).then(function () {
                $state.reload()
              })
            })
          } else {
            PostsService.remove($stateParams.parentId, item.id).then(function () {
              $state.reload()
            })
          }
        } else {
          return
        }
      },
    )
  }

  vm.publish = function (item) {
    PostsService.publish(item.id).then(function () {
      $state.reload()
    })
  }

  vm.unpublish = function (item) {
    PostsService.unpublish(item.id).then(function () {
      $state.reload()
    })
  }

  vm.next = function (item) {
    CacheService.saveId('channelId', $stateParams.parentId)
    $state.go('pub.comments', { parentId: item.id })
  }

  vm.clone = function (item, type) {
    if (type === 2) {
      swal('User posts cannot be cloned', '', 'error')
      return
    }

    var clone = {
      t: item.t,
      txt: item.txt,
      url: item.url,
      urlt: item.urlt,
      'img-h': item['img-h'],
      'id-ch': item['id-ch'],
      k: item.k,
      n: 1,
    }

    if (type === 3) {
      var cache = UserCache.getObject()
      var userId = cache.user.id
      clone['id-a'] = userId
    }

    PostsService.save($stateParams.parentId, clone).then(function (result) {
      toastr.success('Cloned!')
      vm.sortType = 'n-asc'
      vm.sortReverse = false
      loadDraft(vm.pagination.current)
      loadPublished(vm.pagination2.current)
    })
  }

  vm.uploadT = function (item) {
    item.loadT = true
    UploadService.save('posts', vm.pathImgT, 'img-t', item.id).then(function (fileName) {
      item.loadT = false
      item['img-t'] = fileName
    })
  }

  vm.uploadH = function (item) {
    item.loadH = true
    UploadService.save('posts', vm.pathImgH, 'img-h', item.id).then(function (fileName) {
      item.loadH = false
      item['img-h'] = fileName
    })
  }

  vm.back = function () {
    loadDraft(vm.pagination.current)
    loadPublished(vm.pagination2.current)
  }

  vm.showDescription = function (item) {
    $('#myModal').modal('show')
    $('#myModal').on('shown.bs.modal', function () {
      $('#description').html(item)
    })
  }

  vm.disableTable = false
  vm.barConfig = {
    animation: 350,
    onEnd: function (/** ngSortEvent */ evt) {
      vm.disableTable = true
      var newIdx = parseInt(evt.newIndex) + 1
      PostsService.reorder(evt.model.id, newIdx).then(function () {
        vm.sortType = 'n-asc'
        vm.sortReverse = false
        loadDraft(vm.pagination.current)
      })
      // vm.disableTable = true;
      // var actualModel = evt.model;
      // var oldModel = _.find(evt.models, {n: evt.newIndex + 1});
      // actualModel.n = evt.newIndex + 1;
      // oldModel.n = evt.oldIndex + 1;

      // vm.update(actualModel, true, function(){
      // });
    },
  }

  vm.update = function (model, reload, cb) {
    PostsService.update($stateParams.parentId, model.id, { n: model.n }).then(function () {
      if (reload) {
        vm.sortType = 'n-asc'
        vm.sortReverse = false
        loadDraft(vm.pagination.current)
      }

      cb()
    })
  }

  vm.sort = function (type, isTab) {
    if (isTab === 1) {
      vm.sortReverse = !vm.sortReverse
      if (vm.sortReverse) {
        vm.sortType = type + '-asc'
      } else {
        vm.sortType = type + '-desc'
      }
      loadDraft(vm.pagination.current)
    } else {
      vm.sortReverse2 = !vm.sortReverse2
      if (vm.sortReverse2) {
        vm.sortType2 = type + '-asc'
      } else {
        vm.sortType2 = type + '-desc'
      }
      loadPublished(vm.pagination2.current)
    }
  }

  vm.openImage = function (item) {
    if (item.isVideo) {
      window.open(item.video, '_blank')
    } else {
      window.open($rootScope.urlS3 + '/posts/' + item['img-h'], '_blank')
    }
  }
}
